<template>
  <f7-block-title v-if="!hasTransactions">{{$t('title.noTransaction')}}</f7-block-title>
  <f7-list v-else ref="list" class="right-color">
    <f7-list-item v-for="expense in transactions" :key="expense.id" :link="`${links.transaction}/${expense.id}`"
                  :header="expense.date | toDate"
                  :title="expense.description" :after="formatMoney(expense.currency, expense.amount)">
      <f7-icon v-if="!expense.categoryId" slot="media" f7="flag_fill" color="pink"></f7-icon>
      <span slot="footer">
        {{$t('label.receipt')}} <f7-icon :f7="expense.receiptId ? 'checkmark' : 'xmark'" :color="expense.receiptId ? 'blue' : 'pink'"/><br>
        {{$t('label.category')}} <f7-icon :f7="expense.categoryId ? 'checkmark' : 'xmark'" :color="expense.categoryId ? 'blue' : 'pink'"/>
      </span>
    </f7-list-item>
  </f7-list>
</template>

<script>
  import helpers from '@/utils/helpers'

  export default {
    name: 'transaction-list',
    computed: {
      hasTransactions () {
        return this.transactions.length > 0
      }
    },
    mixins: [helpers],
    props: {
      transactions: Array
    }
  }
</script>

<style lang="scss" scoped>
  .item-footer .icon {
    font-size: 12px;
    vertical-align: unset;
  }
</style>
